import * as Preact from 'preact';
import valstore from 'valstore';
import valstoreReactBinding from '../shared/store-react';

const valstoreReact = valstoreReactBinding(Preact);

const store = valstore.create({
  config: {}, // Set in index.js on init/load

  // Local products stored
  local: {
    products: [],
  },

  // ANYTHING put in the 'shopper' keyspace is serialized and stored in a
  // session cookie so that the cart contents can be saved and re-populated if
  // the browser session gets closed
  shopper: {
    cart: {
      items: [],
    },
  },
});

store.connect = (Component, mapStateToProps) => valstoreReact.connect(store, Component, mapStateToProps);

export default store;
